import { BlueTextBoxArrow } from "@/components/ui/box/BlueTextBoxArrow";
import { urlChecker } from "@/components/ui/buttons/ExternalUrlIcons.server";
import { TableRender } from "@/components/ui/tables/TableRender";
import { addressSelector } from "@/utils/addressSelector";
import { formatNumber } from "@/utils/formatNumber";
import { imgSelector } from "@/utils/imgSelector";

import {
  CompanyElement,
  LinkedInWebSiteElement,
  PlainTextInTable,
} from "../AssociatedCompanies/AssociatedCompanies";
import { PersonOverviewWrapper } from "../Overview";

import { AssociatedFundsModal } from "./AssociatedFundsModal";

function AssociatedFunds({ onePerson }) {
  const peopleFundsMask = [
    { title: "Firm" },
    { title: "AUM ($)" },
    { title: "HQ" },
    { title: "Website" },
    { title: "LinkedIn" },
    { title: "Title" },
    { title: "Level" },
  ];
  return (
    <>
      {onePerson?.fundJuctions?.length ? (
        <PersonOverviewWrapper
          customStyleInner={{
            maxW: { base: "100%", md: "100%", xl: "1124px" },
          }}
        >
          <BlueTextBoxArrow
            title="Associated Funds"
            heading="h3"
            headingStyles={{}}
            boxStyles={{}}
          />
          <TableRender
            mask={peopleFundsMask}
            data={onePerson?.fundJuctions}
            customStyleOuter={{ px: "20px", mt: "20px" }}
            blockSwitch={blockSwitch}
            ModalComponent={AssociatedFundsModal}
            history={[]}
          />
        </PersonOverviewWrapper>
      ) : null}
    </>
  );
}

/**
 * Renders the appropriate component based on the table cell type
 * @param {Object} params - The parameters object
 * @param {Object} params.item - The item representing the column
 * @param {Object} params.mainItem - The data item for the current row
 * @returns {JSX.Element|null} - The appropriate component for the table cell
 */
function blockSwitch({ item, mainItem }) {
  switch (item?.title) {
    case "Firm": {
      const nameBrand = mainItem?.resFund?.nameBrand;
      const img = imgSelector({ data: mainItem?.resFund });
      const link = `/investors/funds/${mainItem?.resFund?.slug}`;
      return <CompanyElement {...{ nameBrand, img, link }} />;
    }
    case "AUM ($)": {
      const data = formatNumber(mainItem?.resFund?.aum);
      return <PlainTextInTable {...{ data }} />;
    }
    case "HQ": {
      const data = addressSelector({ data: mainItem?.addresses });
      return <PlainTextInTable data={data} />;
    }
    case "Website": {
      const url = urlChecker(mainItem?.resFund?.webUrl?.urlWebsite);
      return <LinkedInWebSiteElement {...{ url, type: "webSite" }} />;
    }
    case "LinkedIn": {
      const url = urlChecker(mainItem?.resFund?.webUrl?.urlLinkedin);
      return <LinkedInWebSiteElement {...{ url, type: "linkedIn" }} />;
    }
    case "Title": {
      const data = mainItem?.fundStaffFunction;
      return <PlainTextInTable {...{ data }} />;
    }
    case "Level": {
      const data = mainItem?.fundStaffLevel;
      return <PlainTextInTable {...{ data }} />;
    }
  }
  // Default case to ensure all code paths return a value
  return null;
}

export default AssociatedFunds;
